import { FC, useCallback, useState } from 'react';

import ProgressBar from '../../../../components/ProgressBar';
import PeopleCount from '../PeopleCount';
import CalculationContainer from '../CalculationContainer';
import classNames from 'classnames';
import LeftHouse from '../../../../assets/images/metro/game/LeftHouse.svg';
import RightHouse from '../../../../assets/images/metro/game/RightHouse.svg';
import LeftHouseTablet from '../../../../assets/images/metro/game/LeftHouseTablet.svg';
import RightHouseTablet from '../../../../assets/images/metro/game/RightHouseTablet.svg';

import styles from './styles.module.scss';

type Props = {
  className?: string;
  currentLevel: number;
  time: number;
  totalLevels: number;
  isGameOnPause: boolean;
  isProgressOnPause: boolean;
  onEndTime: VoidFunction;
  close: VoidFunction;
  peopleInMetro: number;
  groupSizeRange: [number, number];
  groupAppearanceFrequency: number;
  groupExitTime: number;
  groupMovements: number;
  isActiveQuestion: boolean;
  onChangePeopleInMetro: (value: number) => void;
  onRulesModalToggle: (isOpen: boolean) => void;
};

const OutsideContainer: FC<Props> = ({
  className,
  close,
  currentLevel,
  groupSizeRange,
  isGameOnPause,
  isProgressOnPause,
  onEndTime,
  peopleInMetro,
  time,
  totalLevels,
  groupAppearanceFrequency,
  groupExitTime,
  groupMovements,
  onChangePeopleInMetro,
  onRulesModalToggle
}) => {

  return (
    <div className={classNames(styles.outsideContainer, className)}>
      <img alt="" src={LeftHouse} className={styles.leftHouse} />
      <img alt="" src={RightHouse} className={styles.rightHouse} />
      <img alt="" src={LeftHouseTablet} className={styles.leftHouseTablet} />
      <img alt="" src={RightHouseTablet} className={styles.rightHouseTablet} />

      <div className={styles.progressWrapper}>
        <ProgressBar
          variant="metro"
          currentLevel={currentLevel}
          time={time}
          totalLevels={totalLevels}
          isOnPause={isProgressOnPause}
          onEnd={onEndTime}
          onClose={close}
          onRulesModalToggle={onRulesModalToggle}
        />
        <PeopleCount className={styles.peopleCount} count={peopleInMetro} />
      </div>

      <CalculationContainer
        key={currentLevel}
        className={styles.countPeople}
        groupSizeRange={groupSizeRange}
        groupAppearanceFrequency={groupAppearanceFrequency}
        groupExitTime={groupExitTime}
        groupMovements={groupMovements}
        isProgressOnPause={isProgressOnPause}
        isGameOnPause={isGameOnPause}
        onChangePeopleInMetro={onChangePeopleInMetro}
        peopleInMetro={peopleInMetro}
      />
    </div>
  );
};

export default OutsideContainer;
